module.exports = __webpack_public_path__ + "img/14c3df1.webp";